import axios from "./index";

class supply {
    static onlyUser(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/find/one', params)
    }
    static addSupply(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/insert', params)
    }
    static supplyList(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/list', params)
    }
    static toggleSupply(params) {
        return axios.put(`app-admin/v1/manager/b2b/supplier/${params.lid}/state/${params.type}`)
    }
    static configList(params) {
        return axios.get('app-admin/v1/manager/b2b/supplier/conf/list', { params: params })
    }
    //新增供应配置
    static addConfig(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/conf/insert', params)
    }
    //配置状态修改
    static changeState(params) {
        return axios.put(`app-admin/v1/manager/b2b/supplier/conf/${params.lid}/state/${params.type}`)
    }
    //获取供应供应详情
    static getSupplyDetail(id) {
        return axios.get(`app-admin/v1/manager/b2b/supplier/detail/?id=${id}`)
    }
    //导出供应
    static getData() {
        return axios.get('app-admin/v1/manager/b2b/supplier/download')
    }
    //删除供应
    static removeSupply(params) {
        return axios.get(`app-admin/v1/manager/b2b/supplier/delete`, { params: params })
        // return axios.delete(`app-admin/v1/manager/b2b/supplier/delete`, { data: { businessNo: id } })
    }

    //查询基本配置
    static getBaseConfig(params) {
        return axios.get(`app-admin/v1/manager/baseconfig/getBaseTrainsConfig/${params.configCode}`)
    }

    //更新基本配置
    static setBaseConfig(params) {
        return axios.put('app-admin/v1/manager/baseconfig/updateConfig', params)
    }
}

export default supply